import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  ProceduresFeature,
  isFeatureEnabledForProcedureType,
} from 'procedures/utils/ProcedureCapabilityManagementHelpers';

/**
 * A function which returns if a Worksheet should be considered ReadOnly based upon the Capabilities that the
 * current user has.
 */
export function isExecutionEnabled(procedureType: ProcedureType): boolean {
  return isFeatureEnabledForProcedureType(procedureType, ProceduresFeature.EXECUTE_EXPERIMENT);
}
